const handleSetTheme = (theme: string) => {
    if (/light/.exec(theme) !== null) {
        document.documentElement.style.setProperty(
            "--menu-background-color",
            "#F5F5DC "
          );
    
          document.documentElement.style.setProperty(
            "--sidebar-text-color",
            "black "
          );
        document.documentElement.style.setProperty(
            "--primary-color",
            "rgb(253, 249, 249)"
        );
        document.documentElement.style.setProperty(
            "--secondary-color",
            "rgb(233, 228, 228)"
        );
        document.documentElement.style.setProperty("--text-color", "black");
        document.documentElement.style.setProperty(
            "--sidebar-expand-background-color",
            "white"
        );
        document.documentElement.style.setProperty(
            "--sidebar-expand-text-color",
            "black"
        );
        document.documentElement.style.setProperty(
            "--aggrid-primary-color",
            "rgb(233, 228, 228)"
        );
        document.documentElement.style.setProperty(
            "--aggrid-secondary-color",
            "rgb(253, 249, 249)"
        );
        document.documentElement.style.setProperty(
            "--aggrid-text-color",
            "black"
        );
        document.documentElement.style.setProperty("--appheader-color", "black");
        document.documentElement.style.setProperty(
            "--appheader-background-color",
            "white"
        );
        document.documentElement.style.setProperty(
            "--button-background-color",
            "#0e2b5ab4"
        );
        document.documentElement.style.setProperty("--button-color", "white");
        document.documentElement.style.setProperty(
            "--ag-background-color",
            "white"
        );
    } else if (/dark/.exec(theme) !== null) {
        document.documentElement.style.setProperty(
            "--menu-background-color",
            "#87CEEB "
          );
          document.documentElement.style.setProperty(
            "--sidebar-text-color",
            "#white "
          );
        document.documentElement.style.setProperty("--primary-color", "#2c445c");
        document.documentElement.style.setProperty(
            "--secondary-color",
            "#23344f"
        );
        document.documentElement.style.setProperty("--text-color", "white");
        document.documentElement.style.setProperty(
            "--sidebar-expand-background-color",
            "white"
        );
        document.documentElement.style.setProperty(
            "--sidebar-expand-text-color",
            "black"
        );
        document.documentElement.style.setProperty(
            "--aggrid-primary-color",
            "#23344f"
        );
        document.documentElement.style.setProperty(
            "--aggrid-secondary-color",
            "#2c445c"
        );
        document.documentElement.style.setProperty(
            "--aggrid-text-color",
            "white"
        );
        document.documentElement.style.setProperty(
            "--appheader-background-color",
            "white"
        );
        document.documentElement.style.setProperty("--appheader-color", "black");
        document.documentElement.style.setProperty(
            "--button-background-color",
            "#0e2b5ab4"
        );
        document.documentElement.style.setProperty("--button-color", "white");
    } else if (/green/.exec(theme) !== null) {
        document.documentElement.style.setProperty(
            "--menu-background-color",
            "#20B2AA "
          );
          document.documentElement.style.setProperty(
            "--sidebar-text-color",
            "#white "
          );
        document.documentElement.style.setProperty("--primary-color", "#006D77");
        document.documentElement.style.setProperty(
            "--secondary-color",
            "#83C5BE"
        );
        document.documentElement.style.setProperty("--text-color", "white");
        document.documentElement.style.setProperty(
            "--sidebar-expand-background-color",
            "#83C5BE"
        );
        document.documentElement.style.setProperty(
            "--sidebar-expand-text-color",
            "white"
        );
        document.documentElement.style.setProperty(
            "--aggrid-primary-color",
            "#006D77"
        );
        document.documentElement.style.setProperty(
            "--aggrid-secondary-color",
            "#83C5BE"
        );
        document.documentElement.style.setProperty(
            "--aggrid-text-color",
            "white"
        );
        document.documentElement.style.setProperty(
            "--appheader-color",
            "#006D77"
        );
        document.documentElement.style.setProperty(
            "--button-background-color",
            "#0e2b5ab4"
        );
        document.documentElement.style.setProperty("--button-color", "white");
    }

}
export const SetCurrentTheme = (theme: string) => {
    handleSetTheme(theme);
    // Save theme in cookies
    document.cookie = `theme=${theme}; path=/; max-age=31536000`;
};
const getCookie = (name: string) => {
    const cookies = document.cookie.split("; ");
    const themeCookie = cookies.find((row) => row.startsWith(`${name}=`));
    return themeCookie ? themeCookie.split("=")[1] : null;
};
export const GetThemeName = () => {
    return getCookie("theme") ?? "dark";
}
export const ApplyCurrentTheme = () => {
    const themeName = GetThemeName();
    handleSetTheme(themeName);
};